export type FileBadgeVariant =
  | 'img'
  | 'pdf'
  | 'doc'
  | 'xlsx'
  | 'csv'
  | 'generic'

export interface FileBadge {
  label: string
  variant: FileBadgeVariant
}

const FALLBACK_BADGE: FileBadge = { label: 'FILE', variant: 'generic' }

const EXACT_MIME_BADGES = new Map<string, FileBadge>([
  ['application/pdf', { label: 'PDF', variant: 'pdf' }],
  ['application/msword', { label: 'DOC', variant: 'doc' }],
  [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    { label: 'DOC', variant: 'doc' },
  ],
  [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    { label: 'XLSX', variant: 'xlsx' },
  ],
  ['text/csv', { label: 'CSV', variant: 'csv' }],
])

export function getFileBadge(contentType: string): FileBadge {
  if (contentType.startsWith('image/')) return { label: 'IMG', variant: 'img' }
  return EXACT_MIME_BADGES.get(contentType) ?? FALLBACK_BADGE
}
